import React from "react";
import PropTypes from "prop-types";
import { ContainerEmptyState } from "./styles";

const EmptyState = ({ imageSrc, title, text, tema, marginTop }) => {
  return (
    <ContainerEmptyState tema={tema} marginTop={marginTop}>
      <img src={imageSrc} />
      <span className="emptyStatusTitle">{title}</span>
      <span className="emptyStatusText">{text}</span>
    </ContainerEmptyState>
  );
};

EmptyState.propTypes = {
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  tema: PropTypes.object,
};

export default EmptyState;
